import React from 'react';
import './login.container.sass';
import { useFormik } from 'formik';
import { Input } from '../../../components/interface/input/input';
import { Button } from '../../../components/interface/button/button';
import { useDispatch } from 'react-redux';
import { loginUser } from '../session.slice';
import { useHistory } from 'react-router-dom';
import { Config } from '../../../config/config';
import { unwrapResult } from '@reduxjs/toolkit';

export const LoginContainer = () => {

  const dispatch = useDispatch();
  const history = useHistory();

  const formik = useFormik({
    initialValues: {
      username: '',
      password: ''
    },
    onSubmit: values => {
      dispatch(loginUser(values)).
        then(unwrapResult)
        .then(data => {
          if (!data.first_name) {
            history.push(Config.routePaths.main.vendor.configuration.path);
          } else {
            history.push(Config.routePaths.main.vendor.dashboard.path);
          }
        })
        .catch(e => {

        });
    }
  });

  return (
    <div className='vv-login'>
      <form onSubmit={formik.handleSubmit}>
        <Input type='text'
               placeholder='Email'
               name='username'
               id='username'
               onChange={formik.handleChange}
               value={formik.values.username}/>

        <Input type='password'
               placeholder='Password'
               name='password'
               id='password'
               onChange={formik.handleChange}
               value={formik.values.password}/>
        <Button type='submit' text='Zaloguj'/>
      </form>
    </div>
  );
};
